import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SolidButton } from '../../ui/SolidButton';

import type { Space } from '../../../_hooks/useSpace';

export const JoinBar: FC<{ space: Space }> = ({ space }) => {
  const { t } = useTranslation();

  return (
    <div className="sticky bottom-0 -mx-4 flex flex-col gap-3 border-t border-black/10 bg-white/95 px-4 py-3 backdrop-blur sm:flex-row sm:items-center sm:gap-4 lg:mx-0">
      <p className="flex-1 text-sm leading-5 text-black/70">
        {t('community.cities.looking_in', { channel: space.slug })}
      </p>
      <SolidButton
        variant="primary"
        className="!py-2 text-sm sm:!w-auto sm:px-5"
        onClick={space.onToggle}
        disabled={space.isPending}
      >
        {t('community.cities.join', { channel: space.slug })}
      </SolidButton>
    </div>
  );
};
